/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FAnonymousType112 } from './FAnonymousType112';
import {
    FAnonymousType112FromJSON,
    FAnonymousType112FromJSONTyped,
    FAnonymousType112ToJSON,
    FAnonymousType112ToJSONTyped,
} from './FAnonymousType112';

/**
 * 
 * @export
 * @interface FAnonymousType162
 */
export interface FAnonymousType162 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType162
     */
    id?: number;
    /**
     * 
     * @type {FAnonymousType112}
     * @memberof FAnonymousType162
     */
    definition?: FAnonymousType112;
}

/**
 * Check if a given object implements the FAnonymousType162 interface.
 */
export function instanceOfFAnonymousType162(value: object): value is FAnonymousType162 {
    return true;
}

export function FAnonymousType162FromJSON(json: any): FAnonymousType162 {
    return FAnonymousType162FromJSONTyped(json, false);
}

export function FAnonymousType162FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType162 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'definition': json['definition'] == null ? undefined : FAnonymousType112FromJSON(json['definition']),
    };
}

export function FAnonymousType162ToJSON(json: any): FAnonymousType162 {
    return FAnonymousType162ToJSONTyped(json, false);
}

export function FAnonymousType162ToJSONTyped(value?: FAnonymousType162 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'definition': FAnonymousType112ToJSON(value['definition']),
    };
}

